export default __webpack_public_path__ + "static/media/thumb-GNSS-Antenna-1.3cd8ea00.png";